import React from 'react'
import PropTypes from 'prop-types'

import * as Sentry from '@sentry/react'

import { logAppError } from 'Helpers/logger'

/*

//import { injectIntl } from 'react-intl'

class _ErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    logAppError({
      appError: error,
      appErrorStack: errorInfo
    })
  }

  render() {
    return this.props.children
  }
}

export default injectIntl(ErrorBoundary)
*/

const ErrorBoundary = ({ children }) => {
  const handleError = (error, errorInfo) => {
    console.log('### handleError error', error)
    console.log('### handleError errorInfo', errorInfo)

    logAppError({
      appError: error,
      appErrorStack: errorInfo
    })
  }

  return (
    <Sentry.ErrorBoundary onError={handleError}>
      {children}
    </Sentry.ErrorBoundary>
  )
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
}

export default ErrorBoundary
